import { Input, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DxDataGridComponent, DxTreeListComponent } from 'devextreme-angular';
import { Constants } from 'src/app/app.constants';
import { AlertService } from 'src/app/core/alert.service';
import { AuthService } from 'src/app/core/auth.service';
import { DialogService } from 'src/app/core/dialog.service';
import { LoadingService } from 'src/app/core/loading.service';
import { HttpRequestType, RequestService } from 'src/app/core/request.service';
import { UtilityService } from 'src/app/core/utility.service';
import { BaseListComponent } from 'src/app/shared/base/base-list.component';
import { RouteAuthorities } from 'src/app/shared/base/base.models';
import { BaseService } from 'src/app/shared/base/base.service';

@Component({
  selector: 'app-unit-of-measurement',
  templateUrl: './unit-of-measurement.component.html',
  styleUrls: ['./unit-of-measurement.component.scss']
})
export class UnitOfMeasurementComponent extends BaseListComponent implements OnInit {
  @ViewChild('treeListData', { static: false }) treeList: DxDataGridComponent;
  // @Input('translationKey') translationKey: string;

  allowDropInsideItem: boolean = true;
  allowReordering: boolean = true;
  showDragIcons: boolean = true;
   expandedRowKeys: Array<number> = [1];

  url: string = `${Constants.contextPath}/units-of-measurement`;
  gridListData = [];

  constructor(
    public authService: AuthService,
    public loadingService: LoadingService,
    public baseService: BaseService,
    public dialogService: DialogService,
    public alertService: AlertService,
    public utilityService: UtilityService,
    public requestService: RequestService,
    public translateService: TranslateService
) {
    super(authService, loadingService, baseService, dialogService, alertService, utilityService, requestService, translateService);
    this.authorities = new RouteAuthorities(authService, alertService, 'CD_CD', 'R_CD', 'U_CD', 'CD_CD');
    this.creatable = this.authorities.create;
    this.editable = this.authorities.update;
    this.deletable = this.authorities.delete;
    this.activatable = this.authorities.update;
}

  ngOnInit(): void {
    this.getGridData();
  }

  getGridData() {        
    this.requestService.createRequest(HttpRequestType.Get, `${this.url}/list`, null, null, (response) => {
        this.gridListData = response;
    });
  }

  onRowInserting(event) {
    event.cancel = new Promise<void>((resolve, reject) => {
        this.baseService.create(this.url, event.data, (response) => {
            this.getGridData();
            this.alertService.success('SHARED.SAVE_SUCCESS');
            resolve();
        }, (error) => {
            reject(error.error.error_description || error.error.message);
        })
    });
}

public onRowUpdated(event) {
    event.cancel = new Promise<void>((resolve, reject) => {
        this.baseService.update(this.url, event.data, (response) => {
            this.getGridData();
            this.alertService.success('SHARED.SAVE_SUCCESS');
            resolve();
        }, (error) => {
            reject(error.error.error_description || error.error.message);
        });
    });
}

public onRowRemoving(event) {
    event.cancel = new Promise((resolve, reject) => {
        this.baseService.delete(this.url, event.data.id, (response) => {
            this.getGridData();
            this.alertService.success('SHARED.DELETE_SUCCESS');
        }, (error) => {
            reject(error.error.error_description || error.error.message);
        });
    });
}

}
